import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ContactThematicAreaService {
  static ENDPOINT = `${BASE}/contactThematicArea`;

  static async create(userThematicAreaCreate, auth = false, registrationToken = null) {
    const headers = registrationToken ? { 'X-Registration-Token': registrationToken } : {};
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: userThematicAreaCreate,
      headers,
      auth
    })
  }

  static async getAll({ FK_Contact = null, FK_ThematicArea = null } = {}) {
    const params = new URLSearchParams();
    if (FK_Contact != null) params.set('FK_Contact', FK_Contact);
    if (FK_ThematicArea != null) params.set('FK_ThematicArea', FK_ThematicArea);
    const qs = params.toString();
    return await request({
      url: `${this.ENDPOINT}/` + (qs ? `?${qs}` : ''),
      headers: {'Accept': 'application/json'}
    })
  }

  static async delete(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'DELETE',
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ContactThematicAreaService;
